// extracted by mini-css-extract-plugin
module.exports = {"awardsTable":"style_awardsTable__rBKId","lastupdate":"style_lastupdate__jufiL"};